{
    "Accessibility Menu": "Izbornik Pristupačnosti",
    "Reset settings": "Resetiraj postavke",
    "Close": "Zatvori",
    "Content Adjustments": "Prilagodbe Sadržaja",
    "Adjust Font Size": "Prilagodi Veličinu Fonta",
    "Highlight Title": "Istakni Naslove",
    "Highlight Links": "Istakni Poveznice",
    "Readable Font": "Čitljiv Font",
    "Color Adjustments": "Prilagodbe Boja",
    "Dark Contrast": "Tamni Kontrast",
    "Light Contrast": "Svijetli Kontrast",
    "High Contrast": "Visoki Kontrast",
    "High Saturation": "Visoka Zasićenost",
    "Low Saturation": "Niska Zasićenost",
    "Monochrome": "Jednobojno",
    "Protanopia": "Protanopija",
    "Deuteranopia": "Deuteranopija",
    "Tritanopia": "Tritanopija",
    "Visual & Navigation Aids": "Vizualni i navigacijski pomagači",
    "Additional Tools": "Dodatni alati",
    "Reading Guide": "Vodič Za Čitanje",
    "Stop Animations": "Zaustavi Animacije",
    "Big Cursor": "Veliki Kursor",
    "Screen Reader": "Čitač ekrana",
    "Hide Images": "Sakrij slike",
    "Image Tooltips": "Savjeti za slike",
    "Page Structure": "Struktura stranice",
    "Super Focus": "Super Focus",
    "Magnifier": "Povećalo",
    "Increase Font Size": "Povećaj Veličinu Fonta",
    "Decrease Font Size": "Smanji Veličinu Fonta",
    "Letter Spacing": "Razmak Između Slova",
    "Line Height": "Visina Linije",
    "Font Weight": "Debljina Fonta",
    "Dyslexia Font": "Font Za Disleksiju",
    "Language": "Jezik",
    "Open Accessibility Menu": "Otvori Izbornik Pristupačnosti",
    "Accessibility Profiles": "Profili pristupačnosti",
    "Seizure Safe Profile": "Profil siguran za epileptičare",
    "Stops animations and reduces color saturation.": "Zaustavlja animacije i smanjuje zasićenost boja.",
    "Blind Profile": "Profil za slijepe",
    "Activates the screen reader for auditory navigation.": "Aktivira čitač zaslona za zvučnu navigaciju.",
    "Visually Impaired Profile": "Profil za slabovide",
    "Enhances contrast and readability for low vision.": "Poboljšava kontrast i čitljivost za slabovide.",
    "ADHD Friendly Profile": "Profil pogodan za ADHD",
    "Reduces distractions for better focus.": "Smanjuje ometanje za bolju koncentraciju.",
    "Cognitive & Learning Profile": "Kognitivni i edukacijski profil",
    "Helpful tools for reading and comprehension.": "Korisni alati za čitanje i razumijevanje.",
    "Motor Impaired Profile": "Profil za motoričke poteškoće",
    "Optimizes the site for keyboard-only navigation.": "Optimizira stranicu za navigaciju samo tipkovnicom.",
    "Headings": "Naslovi",
    "Landmarks": "Orijentiri",
    "Links": "Poveznice",
    "Focus element": "Fokusiraj element",
    "Visit link": "Posjeti vezu"
}
